import { render } from "./EmailPhoneForm.vue?vue&type=template&id=2fc86faf&scoped=true"
import script from "./EmailPhoneForm.vue?vue&type=script&lang=js"
export * from "./EmailPhoneForm.vue?vue&type=script&lang=js"

import "./EmailPhoneForm.vue?vue&type=style&index=0&id=2fc86faf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc86faf"]])

export default __exports__